module.exports = __webpack_public_path__ + "media/images/stage1-60b9705b.png";